/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_9993b994"]'><div :class='["custom-swipe-demo"]'><mpx-scroll-view><div :class='["custom-swipe-example"]'><cube-swipe><div v-for="(item, index) in (swipeData)" :key="item.index" :class='["custom-swipe-item-wrapper"]'><cube-swipe-item :item="(item.item)" :btns="(item.btns)" :index="(index)" :use-slot="(true)" :auto-shrink="(true)" @item-click="onItemClick" @btn-click="onBtnClick"><div :class='["custom-swipe-item-inner"]'><mpx-image :src="(item.item.imgurl)" mode="aspectFill" :class='["custom-swipe-item-avatar"]'/><div :class='["custom-swipe-item-content"]'><div :class='["custom-swipe-item-name"]'>{{ item.item.name }}</div><div :class='["custom-swipe-item-desc"]'>{{ item.item.desc }}</div></div></div></cube-swipe-item></div></cube-swipe></div></mpx-scroll-view><cube-action-sheet ref="__mpx_ref_deleteCustomActionSheet__" title="确认要删除吗" :inputData="(deleteActionData)" @select='(e)=>__invoke(e, [["onDeleteSelect"]])'/></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_9993b994"}'>
.custom-swipe-example
  background-color #fff
  border-radius 8px
  overflow hidden

.custom-swipe-item-inner
  display flex
  align-items center
  padding 12px 10px
  background #fff

.custom-swipe-item-avatar
  width 44px
  height 44px
  border-radius 4px
  margin-right 10px

.custom-swipe-item-content
  flex 1
  min-width 0

.custom-swipe-item-name
  color #333
  font-size 15px
  line-height 21px
  white-space nowrap
  overflow hidden
  text-overflow ellipsis

.custom-swipe-item-desc
  margin-top 3px
  color #999
  font-size 12px
  line-height 18px
  white-space nowrap
  overflow hidden
  text-overflow ellipsis
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_9993b994"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_9993b994"}
  /** script content **/
  require("./custom-swipe.mpx.js?isComponent&outputPath=components%2Fcustom-swipe9993b994%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./custom-swipe.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fcustom-swipe9993b994%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_9993b994"],
    ctorType: "component",
    outputPath: "components/custom-swipe9993b994/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-swipe':getComponent(require("../../../packages/mpx-cube-ui/src/components/swipe/index.mpx?isComponent&outputPath=components%2Findex1b0c1aa7%2Findex")),'cube-swipe-item':getComponent(require("../../../packages/mpx-cube-ui/src/components/swipe-item/index.mpx?isComponent&outputPath=components%2Findex4fd03dcd%2Findex")),'cube-action-sheet':getComponent(require("../../../packages/mpx-cube-ui/src/components/action-sheet/index.mpx?isComponent&outputPath=components%2Findex51c8754f%2Findex")),'mpx-scroll-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-scroll-view?isComponent"), {__mpxBuiltIn: true}),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image?isComponent"), {__mpxBuiltIn: true})},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>